import type { ComponentType } from "react";
import type { Artifact } from "@/api/types";
import type { HighlightEntity } from "@/components/artifacts/entityHighlight";
import {
  ListArtifactRenderer,
  TableArtifactRenderer,
  TextArtifactRenderer,
  UnknownArtifactRenderer,
} from "@/components/artifacts/renderers";

export type ArtifactType = Artifact["type"];

export interface RenderedArtifactProps {
  artifact: Artifact;
  /**
   * Forwarded by ArtifactView so renderers that emit inline citation chips
   * (text + list) can hand the click through to the meeting-card transcript
   * tab. Renderers that don't care (table) ignore it.
   */
  onJump?: (startMs: number) => void;
  /**
   * Phase 6: entities whose display name should be wrapped in a coloured
   * `<mark>` chip. Empty / undefined → renderer emits text verbatim.
   */
  highlightEntities?: readonly HighlightEntity[];
}

export type ArtifactRendererMap = Record<
  ArtifactType,
  ComponentType<RenderedArtifactProps>
>;

/**
 * Generic-renderer registry. Adding a new artifact type (e.g. `chart` in v1.1)
 * is a one-line extension here — no changes in the calling component.
 */
export const ARTIFACT_RENDERERS: ArtifactRendererMap = {
  text: TextArtifactRenderer as ComponentType<RenderedArtifactProps>,
  list: ListArtifactRenderer as ComponentType<RenderedArtifactProps>,
  table: TableArtifactRenderer as ComponentType<RenderedArtifactProps>,
};

export { UnknownArtifactRenderer };
